// Shared constants + helpers for the Admin ArticleEditor.
// Kept small and pure so the main component stays readable.

export const MAX_IMAGE_SIZE_BYTES = 3 * 1024 * 1024; // 3 MB — base64 encoded fits comfortably in Mongo (16 MB doc limit)

export const EMPTY_ARTICLE = {
  section: "change_maker",
  slug: "",
  title: "",
  subtitle: "",
  overline: "",
  location: "",
  featured_image: "",
  name: "",
  org: "",
  role: "",
  quote: "",
  quote_attrib: "",
  urgency: "critical",
  donation_partners: [],
  how_to_help: [],
  outlook: { heading: "Looking ahead", body: [""] },
  closing: { heading: "Final thoughts", body: [""] },
  disclaimer: "",
  author_name: "",
  category: "housing",
  intro: "",
  lead: "",
  stats: [],
  sections: [],
  cta: { label: "", href: "" },
  published: true,
};

export const slugify = (s) =>
  (s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

// Deeply set a value at a path array without mutating the original.
export const setPath = (obj, path, value) => {
  const clone = Array.isArray(obj) ? [...obj] : { ...obj };
  let cur = clone;
  for (let i = 0; i < path.length - 1; i++) {
    const k = path[i];
    cur[k] = Array.isArray(cur[k]) ? [...cur[k]] : { ...cur[k] };
    cur = cur[k];
  }
  cur[path[path.length - 1]] = value;
  return clone;
};

// Assign a stable client-side id to a newly-created repeatable list item
// so React key= is not tied to array index (see review: array-index-as-key).
let _uidCounter = 0;
export const withUid = (obj) => ({
  _uid: `row-${Date.now()}-${(_uidCounter += 1)}`,
  ...obj,
});

// Strip fields unrelated to the current article section so the payload stays lean.
export const buildPayload = (form) => {
  const payload = { ...form, slug: slugify(form.slug) };
  if (payload.section !== "appeal") {
    payload.donation_partners = [];
    payload.how_to_help = [];
    payload.outlook = null;
    payload.closing = null;
    payload.disclaimer = "";
    payload.urgency = null;
  }
  if (payload.section !== "change_maker") {
    payload.name = payload.name || payload.title;
    payload.org = payload.org || "";
    payload.role = payload.role || "";
    payload.quote = payload.quote || "";
    payload.quote_attrib = payload.quote_attrib || "";
  }
  if (payload.section !== "story") {
    payload.author_name = payload.author_name || "";
    payload.category = payload.category || "";
  }
  // Strip client-only _uid markers before sending to backend.
  const strip = (arr) => (Array.isArray(arr) ? arr.map(({ _uid, ...rest }) => rest) : arr);
  payload.stats = strip(payload.stats);
  payload.donation_partners = strip(payload.donation_partners);
  if (Array.isArray(payload.sections)) {
    payload.sections = payload.sections.map(({ _uid, ...rest }) => rest);
  }
  return payload;
};
